/**
 * JSON schema version for the analytics timeline output.
 */
export const SCHEMA_VERSION = '1.6.0';
